"use strict";

/**
 * @classdesc
 * Export-Panel des Digitalisierungs-Moduls.
 *
 * @class
 * @extends gc.gis.widget.GCPanel
 * @memberof gc.gis.module.GCDigitize
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 *
 * @param {Object} options Aufrufoptionen
 * @param {gc.gis.module.GCDigitize} options.module Modul-Instanz
 */
gc.gis.module.GCDigitize.ExportPanel = function(options)
{
	gc.gis.assert.isSet(options);
    gc.gis.assert.isInstance(options.module, gc.gis.module.GCDigitize);

	/**
	 * @type {gc.gis.module.GCDigitize}
	 * @private
	 */
	this._module = options.module;
	/**
	 * Speichern-Button (siehe _initActionbar());
	 * @type {gc.gis.widget.GCItem}
	 */
	this._btn_export = null;

	var options_widget = {
		className: 'gc-digitize',
		actionbar: this._initActionbar()
	};

    gc.gis.widget.GCPanel.call(this, options_widget);

	// Inhalt erzeugen
    this.element = this._render();
    this._initContent();
	this._initEvents();
};
gc.gis.module.GCDigitize.ExportPanel.prototype = Object.create(gc.gis.widget.GCPanel.prototype);

/**
 * Initialisiert den Panel-Inhalt
 *
 * @protected
 * @method
 */
gc.gis.module.GCDigitize.ExportPanel.prototype._initContent = function()
{
	var self = this;

	var form_config = {
		className: 'form-featureinfo',
		controls: [
			{
				label: 'Format auswählen',
				name: 'format',
				type: 'select',
				options: [
					{
						label: 'WKT (Well Known Text)',
						value: gc.gis.format.WKT
					},
					{
						label: 'GeoJSON',
						value: gc.gis.format.GEOJSON
					},
					{
						label: 'KML (Keyhole Markup Language)',
						value: 'KML'
					},
					{
						label: 'GPX (GPS Exchange Format)',
						value: 'GPX'
					}
				]
			}
		],
		submit: function(form, params)
		{
			self._onExport(params);
		}
	};

	this._form = gc.gis.util.GCFormRenderer.renderForm(form_config);
	this.element_content.append(this._form.getElement());

	this._updateForm(0, 0, 0);
};

/**
 * Initialisiert die Eventbehandlungsroutinen des Panels.
 *
 * @private
 */
gc.gis.module.GCDigitize.ExportPanel.prototype._initEvents = function()
{
	this._module.on(gc.gis.module.GCDigitizeEvent.FEATURE_ADDED, this, function(evt) {
		this._updateForm(
			evt[gc.gis.geom.GCGeometryType.POINT],
			evt[gc.gis.geom.GCGeometryType.LINESTRING],
			evt[gc.gis.geom.GCGeometryType.POLYGON]
		);
	});
	this._module.on(gc.gis.module.GCDigitizeEvent.FEATURE_REMOVED, this, function(evt) {
		this._updateForm(
			evt[gc.gis.geom.GCGeometryType.POINT],
			evt[gc.gis.geom.GCGeometryType.LINESTRING],
			evt[gc.gis.geom.GCGeometryType.POLYGON]
		);
	});
	this._module.on(gc.gis.module.GCDigitizeEvent.LAYER_CLEARED, this, function(evt) {
		this._updateForm(
			evt[gc.gis.geom.GCGeometryType.POINT],
			evt[gc.gis.geom.GCGeometryType.LINESTRING],
			evt[gc.gis.geom.GCGeometryType.POLYGON]
		);
	});
};

/**
 * Initialisiert die Actionbar.
 *
 * @method
 * @return {Object}
 * @private
 */
gc.gis.module.GCDigitize.ExportPanel.prototype._initActionbar = function()
{
	var self = this;

	this._btn_export = new gc.gis.widget.GCItem({
		label: 'Exportieren',
		className: 'btn btn-success',
		icon: 'action-apply',
		click: function(evt) {
			try
			{
				if (self._btn_export.isEnabled())
				{
					self._form.submit();
					gc.gis.iface.ui.sidebar.historyBack();
				}
			}
			catch(err)
			{
				gc.gis.iface.log.error(self, err);
			}
		}
	});

	var btn_cancel = new gc.gis.widget.GCItem({
		label: 'Abbrechen',
		className: 'btn btn-primary',
		click: function(evt) {
			try
			{
				gc.gis.iface.ui.sidebar.historyBack();
			}
			catch(err)
			{
				gc.gis.iface.log.error(self, err);
			}
		}
	});

	return new gc.gis.widget.GCMenu({
		containerClassName: 'actionbar',
		items: [
			this._btn_export,
			btn_cancel
		]
	})
};

/**
 * Ereignisbehandlungsroutine die zum Exportieren der Objekte aufgerufen wird.
 *
 * @private
 */
gc.gis.module.GCDigitize.ExportPanel.prototype._onExport = function(params)
{
	gc.gis.iface.log.error(this, 'Diese Funktion steht in dieser Version nicht zur Verfügung.');
	console.debug(params);
};

/**
 * Ereignisbehandlungsroutine die bei Änderungen an der Zeichenebene aufgerufen wird.
 *
 * @param {int} numPoints
 * @param {int} numLines
 * @param {int} numPolygons
 * @private
 */
gc.gis.module.GCDigitize.ExportPanel.prototype._updateForm = function(numPoints, numLines, numPolygons)
{
	this._btn_export.setEnabled((numPoints + numLines + numPolygons) > 0);
};